__turbopack_context__.v({
  "image": "Picture-module-scss-module__YMsnFq__image",
  "image-is-background": "Picture-module-scss-module__YMsnFq__image-is-background",
  "image-is-full-width": "Picture-module-scss-module__YMsnFq__image-is-full-width",
  "placeholder": "Picture-module-scss-module__YMsnFq__placeholder",
});
